






// vue
import {Vue, Component} from 'vue-property-decorator';


// 组件
import {Toast} from 'vant';

// http
import http from '@/utils/http';
import {homeInfoAPI, companyInfoAPI} from '@/api/index';

// 工具
import {getLocalStorage} from '@/utils/local-storage';

@Component({

})
export default class App extends Vue {
  public mounted() {
    this.setTitle();
  }

  public setTitle() {
    const {companyInfo} = getLocalStorage();

    if (companyInfo) {
      const {webTitle} = companyInfo;

      if (webTitle) {
        document.title = webTitle;
      }
    }
  }
}
